// extracted by mini-css-extract-plugin
module.exports = {"registerInitForm":"RegisterInitForm_registerInitForm__WHPjK","legend":"RegisterInitForm_legend__VCKUT","login":"RegisterInitForm_login__dAe5c"};